import { useEffect, useState } from 'react'
import { Dialog } from '../../Dialog/Dialog'
import { GridColumn } from '../Grid'
import { useTranslation } from 'react-i18next'
import './FilterModal.scss'

interface FilterModalProps<T> {
  column?: GridColumn<T>
  onChange: (key: string, value: string[] | undefined) => void
  onClose: () => void
}
export function FilterModal<T>(props: FilterModalProps<T>) {
  const [selectedItems, setSelectedItems] = useState<string[]>([])
  const [inputValue, setInputValue] = useState('')
  const [focused, setFocused] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    if (props.column && props.column.filter) {
      setSelectedItems([...props.column.filter])
    } else {
      setSelectedItems([])
    }
  }, [props.column])

  const handleValueSelected = (value: string) => {
    const newItems = [...selectedItems, value]
    setSelectedItems(newItems)
    if (props.column) {
      props.onChange(props.column.key, newItems)
    }
  }

  const handleValueRemoved = (value: string) => {
    const newItems = selectedItems.filter((v) => v !== value)
    setSelectedItems(newItems)
    if (props.column) {
      props.onChange(props.column.key, newItems)
    }
  }

  const changeFocus = (focus: boolean) => {
    if (focus) {
      setFocused(true)
    } else {
      setFocused(false)
    }
  }

  const availableItems = props.column?.filterItems?.filter((i) => !selectedItems.includes(i)).slice(0, 10) ?? []
  const sortedTranslatedAvailableItems = availableItems.map((i) => {
    return { key: t(i.toUpperCase()), value: i }
  })
  return (
    <Dialog title={props.column?.name.toString()} open={!!props.column} onClose={props.onClose} width={500}>
      <div className="grid-filter-modal">
        <div className="grid-filter-items">
          {selectedItems?.map((f, i) => (
            <span key={i} className="grid-filter-item">
              {t(f.toUpperCase())}
              <i className="icon-close" onClick={() => handleValueRemoved(f)} />
            </span>
          ))}
        </div>
        <div className="inputArea">
          <input
            type="text"
            value={inputValue}
            placeholder={`${t('KEYWORDS')}`}
            onChange={(e) => setInputValue(e.currentTarget.value)}
            onFocus={() => changeFocus(true)}
            onBlur={() => changeFocus(false)}
          />
          <i
            className={['icon-bottom', focused ? 'rotate' : ''].join(' ')}
            onClick={() => changeFocus(!focused)}
            hidden={false}
          />
        </div>
        {focused && (
          <div className="filter-search-results">
            <ul>
              {sortedTranslatedAvailableItems.map(({ key, value }, index) => (
                <li key={index} onMouseDown={() => handleValueSelected(value)}>
                  {key}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </Dialog>
  )
}
